import { Close } from '@mui/icons-material';
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Radio, RadioGroup, TextField} from '@mui/material';
import { useState } from 'react';

interface InputProps {
    data: any;
    open: boolean;
    callback: (data: any) => void;
    setInclusiveData: (data: any) => void;
}

function AddDateInclusiveExclusiveInCoupon(props : InputProps) {
    const [inclusiveDate, setInclusiveDate] = useState<boolean>(false);
    const [isDaysOfWeek, setIsDaysOfWeek] = useState<boolean>(false);
    const [selectedDays, setSelectedDays] = useState<string[]>([]);
    const [dateRanges, setDateRanges] = useState<{ startDate: string; endDate: string }[]>([{ startDate: '', endDate: '' }]);

    function handleClose() {
        setInclusiveDate(false);
        setIsDaysOfWeek(false);
        setSelectedDays([]);
        setDateRanges([{ startDate: '', endDate: '' }]);
        props.callback(null);
    }


    function verifyAndSubmit() {
        if (isDaysOfWeek && selectedDays.length === 0) {
            alert("Please select at least one day of the week.");
            return;
        }
        if (!isDaysOfWeek && dateRanges.some(range => range.startDate === '' || range.endDate === '')) {
            alert("Please fill all date ranges.");
            return;
        }
        
        const inclusiveData = {
            type: inclusiveDate ? "inclusion" : "exclusion",
            period: isDaysOfWeek ? "DAYS_OF_WEEK" : "DATE_RANGES",
            values: isDaysOfWeek ? selectedDays : dateRanges
        };
        
        props.setInclusiveData(inclusiveData);
        handleClose();
    }
    

return (
    <>
       <Dialog
            onClose={handleClose}
            open={props.open}
            scroll={"paper"}
            maxWidth="sm"
            fullWidth
        >
                <DialogTitle>Add Inclusive Exclusive Conditions</DialogTitle>
                <DialogContent>
                    <IconButton onClick={handleClose} sx={{ position: 'absolute', top: 2, right: 5 }}> <Close /> </IconButton>
                    <FormControl style={{width:'100%', marginBottom: "20px" }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Grid item xs={4}>
                        <FormControl>
                            <FormLabel id="utensils">Inclusive / Exclusive</FormLabel>
                            <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            onChange={(event: any) => {
                                setInclusiveDate(event.target.value === "true");
                            }}
                            value={inclusiveDate}
                            >
                            <FormControlLabel value={true} control={<Radio />} label="Inclusive" />
                            <FormControlLabel value={false} control={<Radio />} label="Exclusive" />
                            </RadioGroup>
                        </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                        <FormControl>
                            <FormLabel id="utensils">Days of Week</FormLabel>
                                <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                onChange={(event: any) => {
                                    setIsDaysOfWeek(event.target.value === "true");
                                }}
                                value={isDaysOfWeek}
                                >
                                <FormControlLabel value={true} control={<Radio />} label="DAYS_OF_WEEK" />
                                <FormControlLabel value={false} control={<Radio />} label="DATE_RANGES" />
                            </RadioGroup>
                        </FormControl>
                        </Grid>
                        {
                            isDaysOfWeek ? (
                                <Box>
                                <Box fontSize={'1.2rem'}>Days of Week</Box>
                                <Grid container spacing={2} marginTop={'1rem'}>
                                    {['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'].map((day) => (
                                    <Grid item xs={6} key={day}>
                                        <FormControlLabel
                                        control={
                                            <Checkbox
                                            checked={selectedDays.includes(day)}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                setSelectedDays([...selectedDays, day]);
                                                } else {
                                                setSelectedDays(selectedDays.filter((d) => d !== day));
                                                }
                                            }}
                                            />
                                        }
                                        label={day}
                                        />
                                    </Grid>
                                    ))}
                                </Grid>
                                </Box>
                            ) : (
                                <Box>
                                <Box fontSize={'1.2rem'}>Date Ranges</Box>
                                <Grid container spacing={2} marginTop={'1rem'}>
                                    {dateRanges.map((range, index) => (
                                    <Grid item xs={12} key={index}>
                                        <Box fontSize={'1.2rem'}>Start Date</Box>
                                        <TextField
                                        type='date'
                                        value={range.startDate}
                                        onChange={(e) => {
                                            const updatedRanges = [...dateRanges];
                                            updatedRanges[index].startDate = e.target.value;
                                            setDateRanges(updatedRanges);
                                        }}
                                        fullWidth
                                        />
                                        <Box fontSize={'1.2rem'} marginTop={'1rem'}>End Date</Box>
                                        <TextField
                                        type='date'
                                        value={range.endDate}
                                        onChange={(e) => {
                                            const updatedRanges = [...dateRanges];
                                            updatedRanges[index].endDate = e.target.value;
                                            setDateRanges(updatedRanges);
                                        }}
                                        placeholder='End Date'
                                        fullWidth
                                        style={{ marginTop: '1rem' }}
                                        />
                                        <hr style={{ margin: '1rem 0' }} />
                                    </Grid>
                                    ))}
                                    <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => setDateRanges([...dateRanges, { startDate: '', endDate: '' }])}
                                    style={{ marginTop: '1rem' }}
                                    >
                                    Add Date Range
                                    </Button>
                                    <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => {
                                        if (dateRanges.length > 1) {
                                            setDateRanges(dateRanges.slice(0, -1));
                                        }
                                    }}
                                    style={{ marginTop: '1rem', marginLeft: '1rem' }}
                                    >
                                    Remove Last Range
                                    </Button>
                                </Grid>
                                </Box>
                            )
                            }
                        </Box>
                    </FormControl>    
                </DialogContent>
                <DialogActions style={{ marginTop: "12px" }}>
                    <Button
                        variant="contained"
                        onClick={verifyAndSubmit}
                        size={"large"}
                    >
                        Submit
                    </Button>
                    <Button
                        variant="contained"
                        color={"error"}
                        onClick={handleClose}
                        size={"large"}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
    </>
  )
}

export default AddDateInclusiveExclusiveInCoupon